export function formatErrorMessageV2(error?: string) {
  if (!error) return "";

  const firstLetterIndex = error.search(/[A-Za-zÀ-ÖØ-öø-ÿ]/);
  if (firstLetterIndex < 0) return error;

  return `${error.slice(0, firstLetterIndex)}${error[firstLetterIndex].toUpperCase()}${error.slice(firstLetterIndex + 1)}`;
}
